import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What Game Engines Do You Use for 2D Development?",
    answer: `<p>We primarily use Unity and Godot for 2D game development, allowing us to build scalable, high-performance games with robust support for multiple platforms.</p>`,
  },
  {
    question: "How Do You Ensure Smooth Animation in 2D Games?",
    answer: `<p>We use Unity for skeletal and frame-by-frame animations, ensuring smooth, high-quality motion that’s optimized for performance across devices.</p>`,
  },
  {
    question:
      "What Programming Languages Are Used in 2D Game Development Services?",
    answer: `<p>We primarily use C# with Unity and GDScript with Godot, both of which offer powerful tools and flexibility for developing complex game mechanics and systems.</p>`,
  },
  {
    question: "How Do You Optimize 2D Games for Performance?",
    answer: `<p>Our optimization process includes sprite atlasing, memory management, and code profiling to reduce load times, minimize memory usage, and ensure consistent frame rates.</p>`,
  },
  {
    question: "Can You Integrate Multiplayer Features in 2D Games?",
    answer: `<p>Yes, we can implement real-time multiplayer features using Photon or Unity Multiplayer, allowing players to connect and interact in seamless 2D environments.</p>`,
  },
  {
    question:
      "What Post-Launch Support Does Your 2D Game Development Company Offer?",
    answer: `<p>We provide ongoing updates, bug fixes, and feature expansions, using data-driven insights to continuously improve the game based on player feedback and behavior analytics.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>2D Game Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
